<template>
  <div class="promotion_new">
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">New Advert</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>Marketing</b> /

      <router-link to="/promotion">
        Advert
      </router-link>
      /

      <b>New</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <form class="form" @submit.prevent="handleSubmit">
      <div class="form-group">
        <label>Title</label>
        <input v-model="advert.title" class="form-control" placeholder="Advert title" />
      </div>

      <!-- <div class="form-group">
        <label>Push Notification Message</label>
        <textarea v-model="advert.content" class="form-control" placeholder="Push notification message" required></textarea>
      </div> -->

      <div class="form-group">
        <label>Upload Image Link</label>
        <input type="file" id="file" ref="file" v-on:change="handleFileUpload" class="form-control" />
        <br />
        <progress max="100" :value.prop="uploadPercentage"></progress>
      </div>

      <div class="form-group">
        <label>Link (Optional)</label>
        <input v-model="advert.link" class="form-control" placeholder="Advert Link" />
      </div>

      <div class="d-flex flex-row class-flex">
        <div class="form-group flex-grow-1">
          <label>Start Date</label>
          <input v-model="advert.start_at" type="date" class="form-control" required />
        </div>

        <div class="form-group flex-grow-1">
          <label>End Date</label>
          <input v-model="advert.end_at" type="date" class="form-control" required />
        </div>

        <div class="form-group">
          <label>Frequency</label>
          <div class="d-flex flex-row">

            <div v-for="(frequency, index) in frequencies" :key="index">

              <div v-if="frequency.value != 3">
                <label class="radio radio-gold ml-3">
                  <input @click="changeSelectedFrequency(frequency.value)" type="radio" name="activeStatus"
                    v-model="advert.frequency_type" v-bind:value="frequency.value">
                  <div class="d-flex flex-row child-flex-class">
                    <span>{{ frequency.name }}</span>
                    <select :disabled="selectedFrequency != 2" v-if="frequency.value == 2" class="form-control"
                      v-model="advert.weekday" required>
                      <option v-for="day in days" :key="day.value" :value="day.value">{{ day.name }}</option>
                    </select>
                  </div>
                  <span class="checkmark"></span>
                </label>
              </div>
              <div v-else class="d-flex flex-row">
                <label class="radio radio-gold ml-3">
                  <input @click="changeSelectedFrequency(frequency.value)" type="radio" name="activeStatus"
                    v-model="advert.frequency_type" v-bind:value="frequency.value">
                  <span class="checkmark"></span>
                </label>
                <div class="d-flex flex-row justify-evenly">
                  Every <input :disabled="selectedFrequency != 3" class="form-control mx-2"
                    v-model="advert.frequency_days" type="number" /> days
                </div>
              </div>
            </div>

          </div>
        </div>


        <div class="form-group">
          <label>Times</label>
          <input v-model="advert.notification_time" type="time" class="form-control" required />
        </div>
      </div>

      <input type="submit" class="btn btn-primary" />
    </form>
  </div>
</template>

<script>
import { storeAdvert } from '../../../services/PromotionService';

export default {
  name: "advert_new",

  data() {
    return {
      advert: {
        title: "",
        content: "",
        link: null,
        start_at: "",
        end_at: "",
        frequency_type: 1,
        weekday: null,
        frequency_days: null,
        upload: '',
        notification_time: '',
      },

      file: "",
      uploadPercentage: 0,

      frequencies: [
        { value: 1, name: "Daily" },
        { value: 2, name: "Weekly" },
        { value: 3, name: "Custom" }
      ],

      days: [
        { value: 1, name: "Monday" },
        { value: 2, name: "Tuesday" },
        { value: 3, name: "Wednesday" },
        { value: 4, name: "Thursday" },
        { value: 5, name: "Friday" },
        { value: 6, name: "Saturday" },
        { value: 7, name: "Sunday" },
      ],

      selectedFrequency: 1

    };
  },

  watch: {
    selectedFrequency: function (newVal, oldVal) {
      if (this.selectedFrequency != 1) {
        this.advert.weekday = null;
      }

      if (this.selectedFrequency != 3) {
        this.advert.frequency_days = null;
      }
    }
  },

  methods: {
    handleFileUpload() {
      this.advert.upload = this.$refs.file.files[0];
    },

    changeSelectedFrequency(frequency) {
      this.selectedFrequency = frequency;
    },

    appendForm() {
      const dataForm = new FormData();

      dataForm.append('image_link[]', this.advert.upload);
      dataForm.append('title', this.advert.title);
      // dataForm.append('content', this.advert.content);
      dataForm.append('link', this.advert.link);
      dataForm.append('start_at', this.advert.start_at);
      dataForm.append('end_at', this.advert.end_at);
      dataForm.append('frequency_type', this.advert.frequency_type);
      dataForm.append('weekday', this.advert.weekday);
      dataForm.append('frequency_days', this.advert.frequency_days);
      dataForm.append('notification_time', this.advert.notification_time);

      return dataForm;

    },

    async handleSubmit() {
      try {
        const response = await storeAdvert(this.appendForm());

        swal({
          icon: response.data.success ? 'success' : 'error',
          text: response.data.message
        });

        if (response.data.success) {
          this.$router.push({ name: 'promotion-main-page' })
        }

      } catch (e) {
        console.error(e)
      }
    },
  },

  mounted() { }
};
</script>

<style scoped>
.class-flex {
  gap: 20px !important;
}

.child-flex-class {
  gap: 10px !important;
}

.input-flex-class {
  gap: 10px !important;
}
</style>
